// src/pages/Loans/LoanDetail.js
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "../../cstm.style.css";
import FullScreenLoader from "../../components/FullScreenLoader";

const API_BASE = "https://usethecred.com/api";

export default function LoanDetail() {
  // Now expecting route: /loan/:table/:loanId
  const { table, loanId } = useParams();
  const navigate = useNavigate();

  const [personal, setPersonal] = useState(null);
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    if (!loanId || !table) return;

    console.log("Detail table & loanId:", table, loanId);

    setLoading(true);
    setErrorMsg("");

    fetch(
      `${API_BASE}/get_loan_detail.php?table=${encodeURIComponent(
        table
      )}&id=${loanId}`
    )
      .then((res) => res.json())
      .then((data) => {
        console.log("Detail API data:", data);
        if (data.error) {
          setErrorMsg(data.error);
          setPersonal(null);
          setHistory([]);
        } else {
          setPersonal(data.personal || null);
          setHistory(Array.isArray(data.history) ? data.history : []);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching loan detail:", err);
        setErrorMsg("Unable to load loan details.");
        setLoading(false);
      });
  }, [table, loanId]);

  if (loading) return <FullScreenLoader />;

  if (errorMsg || !personal) {
    return (
      <div className="page-bg loan-detail-page">
        <div className="title-header">
          <div className="title-icon">
            <h2 className="page-title">Loan Details</h2>
          </div>
          <button className="btn-primary" onClick={() => navigate(-1)}>
            Back
          </button>
        </div>

        <p className="loan-detail-error">
          {errorMsg || "No details available for this loan."}
        </p>
      </div>
    );
  }

  return (
    <div className="page-bg loan-detail-page">
      <div className="title-header">
        <div className="title-icon">
          <h2 className="page-title">Customer – {personal.name}</h2>
        </div>
        <button className="btn-primary" onClick={() => navigate(-1)}>
          Back
        </button>
      </div>

      {/* Section 1: Personal Information */}
      <section className="card-section">
        <h3 className="card-title">Personal Information</h3>

        <div className="personal-grid">
          <div className="personal-photo-block">
            <div className="field-label">Passport Photo</div>
            {personal.passportPhoto ? (
              <img
                src={personal.passportPhoto}
                alt="Passport"
                className="personal-photo"
              />
            ) : (
              <div className="personal-photo placeholder">No photo</div>
            )}
          </div>

          <div className="personal-fields">
            <div className="field-row">
              <span className="field-label">Name</span>
              <span className="field-value">{personal.name}</span>
            </div>
            <div className="field-row">
              <span className="field-label">Father's Name</span>
              <span className="field-value">{personal.fatherName}</span>
            </div>
            <div className="field-row">
              <span className="field-label">Mother's Name</span>
              <span className="field-value">{personal.motherName}</span>
            </div>
            <div className="field-row">
              <span className="field-label">Phone</span>
              <span className="field-value">{personal.phone}</span>
            </div>
            <div className="field-row">
              <span className="field-label">Email</span>
              <span className="field-value">{personal.email}</span>
            </div>
            <div className="field-row">
              <span className="field-label">Employment Type</span>
              <span className="field-value">
                {personal.employment_type || "-"}
              </span>
            </div>
          </div>
        </div>

        <div className="personal-docs-grid">
          <div className="doc-block">
            <div className="field-label">Aadhar Front</div>
            {personal.aadharFront ? (
              <img
                src={personal.aadharFront}
                alt="Aadhar Front"
                className="doc-image"
              />
            ) : (
              <div className="doc-placeholder">No file</div>
            )}
          </div>
          <div className="doc-block">
            <div className="field-label">Aadhar Back</div>
            {personal.aadharBack ? (
              <img
                src={personal.aadharBack}
                alt="Aadhar Back"
                className="doc-image"
              />
            ) : (
              <div className="doc-placeholder">No file</div>
            )}
          </div>
          <div className="doc-block">
            <div className="field-label">PAN Card</div>
            {personal.panCard ? (
              <img
                src={personal.panCard}
                alt="PAN Card"
                className="doc-image"
              />
            ) : (
              <div className="doc-placeholder">No file</div>
            )}
          </div>
        </div>
      </section>

      {/* Section 2: Loan Information / History */}
      <section className="card-section" style={{ marginTop: "20px" }}>
        <h3 className="card-title">Loan Information (History)</h3>

        {history.length === 0 ? (
          <p className="no-history">No other loans found for this customer.</p>
        ) : (
          <div className="history-table-wrapper">
            <table className="history-table">
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Loan Type</th>
                  <th>Applied Date</th>
                  <th>Bank Statement</th>
                  <th>Doc 1</th>
                  <th>Doc 2</th>
                  <th>Doc 3</th>
                </tr>
              </thead>
              <tbody>
                {history.map((item, index) => (
                  <tr key={item.loan_id || index}>
                    <td>{index + 1}</td>
                    <td>{item.loan_type}</td>
                    <td>{item.submitted_at}</td>
                    <td>
                      {item.docs?.bankStatement ? (
                        <a
                          href={item.docs.bankStatement}
                          target="_blank"
                          rel="noreferrer"
                        >
                          Download
                        </a>
                      ) : (
                        "-"
                      )}
                    </td>
                    <td>
                      {item.docs?.doc1 ? (
                        <a
                          href={item.docs.doc1}
                          target="_blank"
                          rel="noreferrer"
                        >
                          Download
                        </a>
                      ) : (
                        "-"
                      )}
                    </td>
                    <td>
                      {item.docs?.doc2 ? (
                        <a
                          href={item.docs.doc2}
                          target="_blank"
                          rel="noreferrer"
                        >
                          Download
                        </a>
                      ) : (
                        "-"
                      )}
                    </td>
                    <td>
                      {item.docs?.doc3 ? (
                        <a
                          href={item.docs.doc3}
                          target="_blank"
                          rel="noreferrer"
                        >
                          Download
                        </a>
                      ) : (
                        "-"
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </section>
    </div>
  );
}
